import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Modal, notification } from "antd";
import moment from "moment";
import { withProcedureWraper } from "../../../../..";
import { ApprovalHistory, Box, ButtonList, Error, FileList, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { ChatsV2 } from "../../../../../../../components/ui/chats/index-v2";
import { RequestStatus } from "../../../../../../../constants";
import { StringHelper } from "../../../../../../../helper";
import { useUser } from "../../../../../../../hook";
import { ProcessLeaveRequestPayload } from "../../../../../../../services/vos/leave-request/leave-request.service";
import ApprovalProcess, {
  ApprovalProcessApprover,
  ApprovalProcessHistory,
} from "../../../../../company-office/business-tickets-v2/components/approval-process";
import { VacationHistoryTable } from "../../../components";
import { useAFLRequest, useAFLSteps, useProcessLeaveRequest, useUpdateAFL, useVacationPersonal } from "../../../hooks";
import { getBackLink, getDetailTemplate } from "../../../utils";

const requestFallback = {};

// TODO: Chi tiết đơn xin nghỉ phép
const AbsenceLetterDetail = withProcedureWraper(() => {
  const history = useHistory();
  const [reason, setReason] = useState("");
  const [activeStep, setActiveStep] = useState(-1);
  const { checkCurrentUser } = useUser();

  const {
    data: request = requestFallback,
    isLoading: isRequestLoading,
    isFetching: isRequestFetching,
    isError,
  } = useAFLRequest();

  const [aflType] = StringHelper.verticalBarSplit(request?.eAFLType);
  const { mutate } = useUpdateAFL();
  const { process, getHistories } = useAFLSteps();
  const { pathname } = useLocation();

  const { mutateAsync: processLeaveRequest, isLoading: isProcessLeaveRequestLoading } = useProcessLeaveRequest();

  // Lấy năm hiện tại và hrId từ request
  const currentYear = moment().year();

  // Fetch lịch sử nghỉ phép - Di chuyển hook lên trước các điều kiện return sớm
  const { data: vacationData, isLoading: isVacationLoading } = useVacationPersonal({
    year: currentYear,
    hrId: request?.createdHrId || 0, // Sử dụng hrId từ request hoặc fallback về 1751
  });

  // const siteUrl = getSiteUrl(aflType, pathname);
  const backLink = getBackLink(aflType, pathname);

  // Di chuyển các hooks lên trước early returns để đảm bảo hooks được gọi cùng thứ tự
  const eSteps = request?.eSteps;
  const current = request?.eApprovalProcess?.current;
  const eComments = request?.eComments;
  const eRequestStatus = request?.eRequestStatus;

  const approvalSteps = useMemo<ApprovalProcessApprover[][]>(() => {
    if (!eSteps?.length) return [];

    return eSteps.map((step: any[]) => {
      return (step || []).map((item: any) => {
        const histories: ApprovalProcessHistory[] = [];

        // Chuyển đổi histories từ eSteps format sang ApprovalProcess format
        if (item.histories && Array.isArray(item.histories)) {
          item.histories.forEach((history: any) => {
            if (history.updatedDateTime) {
              if (history.status) {
                histories.push({
                  label: history.label || "",
                  status: history.status.toLowerCase(),
                  updatedDateTime: history.updatedDateTime,
                  reason: history.reason || "",
                });
              }
            }
          });
        }

        return {
          title: item.title || "",
          name: item.name || "",
          email: item.email || "",
          isRequired: item.isRequired !== false,
          roles: item.roles || [],
          isApproved:
            item.isApproved === true && !(item.histories || []).some((h: any) => h.status === RequestStatus.rejected),
          isRejected:
            item.isRejected === true || (item.histories || []).some((h: any) => h.status === RequestStatus.rejected),
          histories,
          isSub: item.DutyType === "SUB" || item.dutyType === "SUB",
        };
      });
    });
  }, [eSteps]);

  const allowSteps = useMemo(() => {
    if (current <= 0 || !eSteps?.length) return [];
    const steps = new Array(current).fill(null).map((_, index) => index + 1);
    return steps;
  }, [current, eSteps]);

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  const isVOS = Boolean(request?.vRegID);

  const { canApprove, canEdit, canCancel, canRecover } = process({
    current: request.eApprovalProcess.current,
    steps: request.eSteps,
    eRequestStatus: request.eRequestStatus,
    isVOS,
  });

  const approvalHistory = getHistories(eSteps);

  const handleClickStep = (step: number) => {
    setActiveStep(activeStep === step ? -1 : step);
  };

  const onApproveClick = () => {
    const isFinished = current + 2 === eSteps.length;

    const approvalItem = eSteps[current + 1].find((item: any) => checkCurrentUser(item.email) && !item.isApproved);

    if (!approvalItem) {
      notification.warning({
        message: "Thông báo!",
        description: `Không tìm thấy người phê duyệt.`,
      });
      return;
    }

    const body: ProcessLeaveRequestPayload = {
      id: request.id,
      email: approvalItem.email,
      RequestStatus: isFinished ? RequestStatus.completed : eRequestStatus,
      VAppId: approvalItem.vAppId,
      Reason: reason,
      Step: current + 1,
      VRegID: request.vRegID,
      // Approvals: [
      //   {
      //     Email: approvalItem.email,
      //     Name: approvalItem.name,
      //     Step: current + 1,
      //     VAppId: approvalItem.vAppId,
      //   },
      // ],
    };

    processLeaveRequest(body, {
      onSuccess: () => {
        notification.success({
          message: "Thành công!",
          description: `Duyệt yêu cầu thành công.`,
        });
      },
      onError: (error: any) => {
        console.log("🚀 ~ onApproveClick ~ error:", error);

        notification.error({
          message: "Thất bại",
          description: `Duyệt yêu cầu thất bại.`,
        });
      },
    });

    // const vars = {
    //   id: request.id,
    //   body: {
    //     eSteps: newSteps,
    //     eRequestStatus: isFinished ? RequestStatus.completed : eRequestStatus,
    //     eApprovalProcess: {
    //       current: getCurrent(newSteps[current + 1], current),
    //       status: "finish",
    //     },
    //   },
    // };

    // updateApplicationForLeave(vars, {
    //   onSuccess(response: any = {}) {
    //     const { id, eRequestStatus, eRequestName, eEmail } = response;
    //     const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;
    //     notifyFn({
    //       steps: JSON.parse(response.eSteps),
    //       toPath: `${siteUrl}/${id}`,
    //       eRequestStatus,
    //       current: JSON.parse(response.eApprovalProcess).current,
    //       requestUser: { name: eRequestName, email: eEmail },
    //       reason,
    //       aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
    //     });
    //   },
    // });
  };

  const handleRejectWithConfirm = () => {
    Modal.confirm({
      title: "Xác nhận không đồng ý",
      content: "Anh/chị có chắc chắn không đồng ý yêu cầu này?",
      okText: "Xác nhận",
      cancelText: "Bỏ qua",
      onOk: () => onRejectClick(),
    });
  };

  const onRejectClick = () => {
    if (!reason) {
      notification.warning({
        message: "Thông báo!",
        description: `Vui lòng nhập lý do.`,
      });
      return;
    }

    const rejectItem = eSteps[current + 1].find((item: any) => checkCurrentUser(item.email) && !item.isApproved);
    if (!rejectItem) {
      notification.warning({
        message: "Thông báo!",
        description: `Không tìm thấy người phê duyệt.`,
      });
      return;
    }

    const body: ProcessLeaveRequestPayload = {
      id: request.id,
      email: rejectItem.email,
      RequestStatus: RequestStatus.rejected,
      VAppId: rejectItem.vAppId,
      Reason: reason,
      Step: current + 1,
      VRegID: request.vRegID,
      // Approvals: [{ Email: rejectItem.email, Name: rejectItem.name, Step: step, VAppId: rejectItem.vAppId }],
    };

    console.log("body", body);

    processLeaveRequest(body, {
      onSuccess: () => {
        notification.success({
          message: "Thành công!",
          description: `Từ chối yêu cầu thành công.`,
        });
      },
      onError: (error: any) => {
        console.log("🚀 ~ onRejectClick ~ error:", error);

        notification.error({
          message: "Thất bại",
          description: `Từ chối yêu cầu thất bại.`,
        });
      },
    });
    // const vars = {
    //   id: request.id,
    //   body: {
    //     eSteps: newSteps,
    //     eRequestStatus: RequestStatus.rejected,
    //     eApprovalProcess: {
    //       current: getCurrent(newSteps[current + 1], current),
    //       status: "error",
    //     },
    //   },
    // };
    // updateApplicationForLeave(vars, {
    //   successText: "Từ chối yêu cầu thành công",
    //   errorText: "Từ chối yêu cầu thất bại",
    //   onSuccess(response: any) {
    //     const { id, eRequestStatus, eRequestName, eEmail } = response;
    //     const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;

    //     notifyFn({
    //       steps: JSON.parse(response.eSteps),
    //       toPath: `${siteUrl}/${id}`,
    //       eRequestStatus,
    //       current: JSON.parse(response.eApprovalProcess).current,
    //       requestUser: { name: eRequestName, email: eEmail },
    //       reason,
    //       aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
    //     });
    //   },
    // });
  };

  const onCancelClick = () => {
    // const newSteps = getNewSteps(eSteps, 0, "cancel");

    const initStep = eSteps?.[0]?.[0];

    const body: ProcessLeaveRequestPayload = {
      id: request.id,
      email: initStep.email,
      RequestStatus: RequestStatus.canceled,
      VAppId: initStep.vAppId,
      Reason: reason,
      Step: 0,
      VRegID: request.vRegID,
      // Approvals: [{ Email: initStep.email, Name: initStep.name, Step: 0, VAppId: initStep.vAppId }],
    };

    console.log("body", body);

    processLeaveRequest(body, {
      onSuccess: () => {
        notification.success({
          message: "Thành công!",
          description: `Huỷ bỏ yêu cầu thành công.`,
        });
      },
      onError: async (error: any) => {
        notification.error({
          message: "Thất bại",
          description: `Huỷ bỏ yêu cầu thất bại.`,
        });
      },
    });
    // const vars = {
    //   id: request.id,
    //   body: {
    //     eSteps: newSteps,
    //     eRequestStatus: RequestStatus.canceled,
    //     eApprovalProcess: {
    //       current: 0,
    //       status: "finish",
    //     },
    //   },
    // };
    // updateApplicationForLeave(vars, {
    //   successText: "Huỷ bỏ yêu cầu thành công",
    //   errorText: "Huỷ bỏ yêu cầu thất bại",
    //   onSuccess(response: any) {
    //     const { id, eRequestStatus, eRequestName, eEmail } = response;
    //     const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;
    //     notifyFn({
    //       steps: JSON.parse(response.eSteps),
    //       toPath: `${siteUrl}/${id}`,
    //       eRequestStatus,
    //       current: JSON.parse(response.eApprovalProcess).current,
    //       requestUser: { name: eRequestName, email: eEmail },
    //       reason,
    //       aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
    //     });
    //   },
    // });
  };

  const onRecoverClick = () => {
    // const newSteps = getNewSteps(eSteps, 0, "recover");

    const initStep = eSteps?.[0]?.[0];
    const body: ProcessLeaveRequestPayload = {
      id: request.id,
      email: initStep.email,
      RequestStatus: RequestStatus.revoked,
      VAppId: initStep.vAppId,
      Reason: reason,
      Step: 0,
      VRegID: request.vRegID,
      // Approvals: [{ Email: initStep.email, Name: initStep.name, Step: 0, VAppId: initStep.vAppId }],
    };

    console.log("body", body);

    processLeaveRequest(body, {
      onSuccess: () => {
        notification.success({
          message: "Thành công!",
          description: `Thu hồi yêu cầu thành công.`,
        });
      },
      onError: (error: any) => {
        console.log("🚀 ~ onRecoverClick ~ error:", error);

        notification.error({
          message: "Thất bại",
          description: `Thu hồi yêu cầu thất bại.`,
        });
      },
    });

    // const vars = {
    //   id: request.id,
    //   body: {
    //     eSteps: newSteps,
    //   },
    // };
    // updateApplicationForLeave(vars, {
    //   successText: "Thu hồi yêu cầu thành công",
    //   errorText: "Thu hồi yêu cầu thất bại",
    //   onSuccess(response: any) {
    //     const { id, eRequestStatus, eRequestName, eEmail } = response;
    //   },
    // });
  };

  const TemplateDetail = getDetailTemplate(aflType);

  return (
    <ProcedureLayout title="XEM XÉT YÊU CẦU DUYỆT" loading={isRequestFetching} backLink={backLink}>
      {approvalSteps.length > 0 && (
        <ApprovalProcess
          activeStep={activeStep}
          allowClickSteps={allowSteps}
          steps={approvalSteps}
          loading={isRequestFetching}
          onClickStep={handleClickStep}
        />
      )}
      <Box title="Thông tin">
        <TemplateDetail data={request} />

        {/* {medicalStaffAFLTypes.includes(aflType) && (
          <BoxSection title="Thông tin giám định">
            <InspectionInformation data={request} />
          </BoxSection>
        )} */}
      </Box>

      <Box title="Tệp đính kèm">
        <FileList files={request.eAttachments} />
      </Box>

      <Box title="Thông tin trao đổi">
        <ChatsV2 requestId={request.id} items={eComments} mutateFn={mutate} />
      </Box>

      <Box title="Lịch sử phê duyệt">
        <ApprovalHistory showComment={canApprove} items={approvalHistory} value={reason} onChange={setReason} />
        <div className="flex-center mt-4">
          <ButtonList
            items={[
              {
                buttonType: "success",
                label: "Đồng ý",
                onClick: onApproveClick,
                hidden: !canApprove,
                isLoading: isProcessLeaveRequestLoading,
              },
              {
                buttonType: "grey",
                label: "Không đồng ý",
                onClick: handleRejectWithConfirm,
                hidden: !canApprove,
                isLoading: isProcessLeaveRequestLoading,
              },
              {
                buttonType: "warning",
                label: "Chỉnh sửa",
                hidden: !canEdit,
                onClick: () => history.push(`${backLink}/${request.id}/edit`),
                isLoading: isProcessLeaveRequestLoading,
              },
              {
                buttonType: "danger",
                label: "Huỷ bỏ",
                hidden: !canCancel,
                onClick: onCancelClick,
                isLoading: isProcessLeaveRequestLoading,
              },
              {
                buttonType: "danger",
                label: "Thu hồi",
                hidden: !canRecover,
                onClick: onRecoverClick,
                isLoading: isProcessLeaveRequestLoading,
              },
            ]}
          />
        </div>
      </Box>

      <Box title="Lịch sử nghỉ phép">
        <VacationHistoryTable
          data={vacationData?.Data?.LeaveRequests || []}
          totalApproved={vacationData?.Data?.TotalApproved || 0}
          totalPending={vacationData?.Data?.TotalPending || 0}
          loading={isVacationLoading}
        />
      </Box>
    </ProcedureLayout>
  );
});

export default AbsenceLetterDetail;
